import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { PAYER_ROLES } from "@/lib/billing-payer";
import type { OrgPayer } from "@/lib/account-resolve";

interface BillingContactRow {
  full_name: string | null;
  email: string | null;
  role: string;
  via_agency: boolean | null;
}

export function toOrgPayers(rows: BillingContactRow[] | null | undefined): OrgPayer[] {
  return (rows ?? [])
    .filter((row) => PAYER_ROLES.includes(row.role))
    .map((row) => ({
      name: row.full_name || row.email || "Administrador",
      email: row.email || null,
      role: row.role,
      viaAgency: row.via_agency === true,
    }));
}

export function useOrgPayers(orgId: string | null, enabled: boolean): { payers: OrgPayer[]; loading: boolean } {
  const [payers, setPayers] = useState<OrgPayer[]>([]);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    setPayers([]);
    if (!orgId || !enabled) {
      setLoading(false);
      return;
    }
    let active = true;
    setLoading(true);
    (async () => {
      const { data, error } = await supabase.rpc("get_org_billing_contacts");
      if (!active) return;
      setPayers(error ? [] : toOrgPayers(data as BillingContactRow[] | null));
      setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, [orgId, enabled]);

  return { payers, loading };
}
